export default __webpack_public_path__ + "static/media/uk-icon.55ef8e01.svg";